import * as Animate from "react-reveal";

const markStyle = {
  background: "linear-gradient(transparent 66%, #fbaf1be6 0)",
  padding: "0 0.08em",
  color: "inherit",
};

const PayFinalCtaSection = () => {
  return (
    <section className="bg-primary text-white py-14 lg:py-[70px] px-6 lg:px-8">
      <div className="container mx-auto flex flex-col lg:flex-row lg:justify-between lg:items-center gap-8 lg:gap-[50px]">
        <Animate.Fade bottom>
          <div>
            <p className="text-secondary tracking-[0.1em] uppercase text-[15px] font-black mb-[13px]">
              Your Team Is Global
            </p>
            <h2
              className="tracking-[-0.045em] leading-[1.03] font-black mb-[13px]"
              style={{ fontSize: "clamp(40px, 4vw, 60px)" }}
            >
              Make payday feel <mark style={markStyle}>closer.</mark>
            </h2>
            <span className="text-[#dce1ff] text-[18px] block">
              One coordinated payroll experience, supported by people who
              understand global teams.
            </span>
          </div>
        </Animate.Fade>

        <Animate.Fade bottom>
          <a
            href="https://app.utiva.co/signup?goal=workforce"
            target="_blank"
            rel="noreferrer noopener"
            className="bg-secondary text-primary rounded-[11px] inline-flex items-center gap-5 shrink-0 text-[16px] font-black px-[21px] py-4 hover:-translate-y-0.5 transition-all"
            style={{ minHeight: "58px" }}
          >
            Request a demo <span aria-hidden="true">↗</span>
          </a>
        </Animate.Fade>
      </div>
    </section>
  );
};

export default PayFinalCtaSection;
